import { createColumnHelper } from '@tanstack/react-table';
import { Typography } from '@weareopenr/component-library';
import { channelsLogoHandler } from 'src/pages/Venue/channelsLogoHandler/channelsLogoHandler';
import { IChannel } from 'src/types/venue.types';
import ChannelLogo from 'src/components/ChannelLogo';
import styles from '../VenueChannels.module.scss';

export const mapChannelsToTable = (channels: IChannel[]) => {
  return channels.map((channel: IChannel) => ({
    id: channel.channelId,
    name: channel.name,
    externalId: channel.externalId,
    externalBrandId: channel.externalBrandId,
  }));
};

const columnHelper = createColumnHelper<ReturnType<typeof mapChannelsToTable>[number]>();

export const channelColumns = [
  columnHelper.accessor('name', {
    header: 'Channel',
    cell: ({ row }) => {
      const logo = channelsLogoHandler(row.original.name);
      return (
        <div className={styles['channel-details']}>
          <ChannelLogo src={logo} alt={row.original.name} className={styles['logo']} />
          <Typography>{row.original.name}</Typography>
        </div>
      );
    },
  }),
  columnHelper.accessor('externalId', {
    header: 'Venue ID',
    cell: ({ getValue }) => <Typography>{getValue() ?? '-'}</Typography>,
  }),
  columnHelper.accessor('externalBrandId', {
    header: 'External brand ID',
    cell: ({ getValue }) => <Typography>{getValue() ?? '-'}</Typography>,
  }),
];
